import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  standalone: false,
})
export class ConfirmationPopupComponent {
  public title: string;

  public description: string;

  public type: string = 'close'; // Available default, close

  public generateBtnTitle: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.description = data.description;
    this.generateBtnTitle = data.generateBtnTitle;
  }

  generate() {
    this.dialogRef.close('confirmation');
  }

  close(): void {
    this.dialogRef.close();
  }
}
